import { createContext, useContext } from 'react';

export const UserCountryContext = createContext<string | undefined>("");
export const useUserCountry = () => useContext(UserCountryContext);
